import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=2a2c96b0&"
import script from "./AppFooter.vue?vue&type=script&lang=js&"
export * from "./AppFooter.vue?vue&type=script&lang=js&"
import style0 from "./AppFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a2c96b0')) {
      api.createRecord('2a2c96b0', component.options)
    } else {
      api.reload('2a2c96b0', component.options)
    }
    module.hot.accept("./AppFooter.vue?vue&type=template&id=2a2c96b0&", function () {
      api.rerender('2a2c96b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/AppFooter.vue"
export default component.exports